import { render, staticRenderFns } from "./edit-testQuestionUs.vue?vue&type=template&id=80b6d5d0&scoped=true&"
import script from "./edit-testQuestionUs.vue?vue&type=script&lang=ts&"
export * from "./edit-testQuestionUs.vue?vue&type=script&lang=ts&"
import style0 from "./edit-testQuestionUs.vue?vue&type=style&index=0&id=80b6d5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b6d5d0",
  null
  
)

export default component.exports